export const ANTIGRAVITY_TARGET = 'antigravity';

export const ANTIGRAVITY_DIR = '.agents';
export const ANTIGRAVITY_RULES_DIR = `${ANTIGRAVITY_DIR}/rules`;
/** Generated main workspace instructions (canonical root remains `.agentsmesh/rules/_root.md`). */
export const ANTIGRAVITY_RULES_ROOT = `${ANTIGRAVITY_RULES_DIR}/general.md`;
export const ANTIGRAVITY_RULES_ROOT_LEGACY = `${ANTIGRAVITY_RULES_DIR}/_root.md`;
export const ANTIGRAVITY_SKILLS_DIR = `${ANTIGRAVITY_DIR}/skills`;
export const ANTIGRAVITY_WORKFLOWS_DIR = `${ANTIGRAVITY_DIR}/workflows`;
export const ANTIGRAVITY_MCP_CONFIG = `${ANTIGRAVITY_DIR}/antigravity/mcp_config.json`;

export const ANTIGRAVITY_HOOKS_FILE = `${ANTIGRAVITY_DIR}/hooks.json`;
export const ANTIGRAVITY_GLOBAL_HOOKS_FILE = '.gemini/config/hooks.json';

export const ANTIGRAVITY_GLOBAL_ROOT = '.gemini/antigravity/GEMINI.md';
export const ANTIGRAVITY_GLOBAL_SKILLS_DIR = '.gemini/antigravity/skills';
export const ANTIGRAVITY_GLOBAL_WORKFLOWS_DIR = '.gemini/antigravity/workflows';
export const ANTIGRAVITY_GLOBAL_MCP_CONFIG = '.gemini/antigravity/mcp_config.json';

export const ANTIGRAVITY_CANONICAL_ROOT_RULE = '.agentsmesh/rules/_root.md';
export const ANTIGRAVITY_CANONICAL_RULES_DIR = '.agentsmesh/rules';
export const ANTIGRAVITY_CANONICAL_COMMANDS_DIR = '.agentsmesh/commands';
export const ANTIGRAVITY_CANONICAL_MCP = '.agentsmesh/mcp.json';
